/* ==========================================================
   ShoeCharms.shop
   Cloudinary Upload
========================================================== */

document.addEventListener("DOMContentLoaded", function () {

    const uploadButton = document.getElementById("CloudinaryUpload");
    if (!uploadButton) return;

    const preview = document.getElementById("UploadPreview");
    const placeholder = document.getElementById("UploadPlaceholder");

    const imageURL = document.getElementById("PetPhotoURL");
    const publicID = document.getElementById("CloudinaryPublicID");

    const replaceButton = document.getElementById("ReplacePhoto");
    const removeButton = document.getElementById("RemovePhoto");

    const addToCartButton = document.getElementById("AddToCartButton");

    const cloudName = uploadButton.dataset.cloudName;
    const uploadPreset = uploadButton.dataset.uploadPreset;

    const widget = cloudinary.createUploadWidget({

        cloudName: cloudName,
        uploadPreset: uploadPreset,

        multiple: false,
        cropping: false,

        folder: "shoe-charms",

        clientAllowedFormats: [
            "jpg",
            "jpeg",
            "png",
            "webp",
            "heic"
        ],

        maxImageFileSize: 10000000,

        sources: [
            "local",
            "camera",
            "google_drive",
            "dropbox"
        ],

        showAdvancedOptions: false,
        theme: "minimal"

    }, function(error, result){

        if (error) {
            console.error(error);
            return;
        }

        if (!result || result.event !== "success") {
            return;
        }

        console.log("Cloudinary Upload:", result);

        imageURL.value = result.info.secure_url;
        publicID.value = result.info.public_id;

        preview.src = result.info.secure_url;
        preview.style.display = "block";

        placeholder.style.display = "none";

        replaceButton.style.display = "inline-flex";
        removeButton.style.display = "inline-flex";

        if (addToCartButton) {
            addToCartButton.disabled = false;
            addToCartButton.textContent = "Add To Cart";
        }

    });

    uploadButton.addEventListener("click", function () {
        widget.open();
    });

    if (replaceButton) {
        replaceButton.addEventListener("click", function () {
            widget.open();
        });
    }

    if (removeButton) {
        removeButton.addEventListener("click", function () {

            imageURL.value = "";
            publicID.value = "";

            preview.src = "";
            preview.style.display = "none";

            placeholder.style.display = "block";

            replaceButton.style.display = "none";
            removeButton.style.display = "none";

            if (addToCartButton) {
                addToCartButton.disabled = true;
                addToCartButton.textContent = "Upload Photo First";
            }

        });
    }

});